import { Deferred } from 'common/dynamicquery/deferred';

export function StreamConnector(WebSocketStream) {
  /*
   Tries to connect through WebSocket, if it fails it tries to connect through IFrame.
   Connect resolves only if the connection is estabilished.
   WebSocket can fail either because the browser does not support it or the firewall blocks it
   */
  let deferred;

  return {
    connect: connect
  };

  function connect(clientInfo, messageCallback) {
    deferred = new Deferred();

    _tryConnectViaWebSocket(clientInfo, messageCallback)
      .catch(function(){
        deferred.reject();
      });

    return deferred.promise;
  }

  function _tryConnectViaWebSocket(clientInfo, messageCallback) {
    return WebSocketStream.connect(clientInfo, messageCallback)
      .then(function () {
        deferred.resolve(WebSocketStream);
      });
  }
}
